import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Inspiration = () => {
  return (
    <div>
      <h3 className="text-center mt-5">INSPIRATION</h3>
      <div className="container-fluid">
      <Row lg={3}>
        <Col sm={12}>
          <Card style={{ border:"none"  }}>
            <Card.Img
              variant="top"
              style={{ height: "340px" }}
              src="https://i.ibb.co/X7J3yj7/blog1.jpg"
            />
            <Card.Body className="text-center">
                <span>NEWS</span>
              <Card.Title>Chocolate Cornstarch Pudding</Card.Title>
           <p>Where can i get some? The new site provides a closer look at our agency- What connects us,What excites us.......</p>
           <Link to="/package.jsonblogs">Readmore</Link>
            </Card.Body>
          </Card>
        </Col>      
        <Col sm={12}>
          <Card style={{ border:"none"  }}>
            <Card.Img
              variant="top"
              style={{ height: "340px" }}
              src="https://i.ibb.co/F6DzStC/blog2.jpg"
            />
            <Card.Body className="text-center">
                <span>NEWS</span>
              <Card.Title>Chocolate Cornstarch Pudding</Card.Title>
           <p>Where can i get some? The new site provides a closer look at our agency- What connects us,What excites us.......</p>
           <Link to="/package.jsonblogs">Readmore</Link>
            </Card.Body>
          </Card>
        </Col>      
        <Col sm={12}>
          <Card style={{ border:"none"  }}>
            <Card.Img
              variant="top"
              style={{ height: "340px" }}
              src="https://i.ibb.co/m9fNrVz/blog3.jpg"
            />
            <Card.Body className="text-center">
                <span>NEWS</span>
              <Card.Title>Chocolate Cornstarch Pudding</Card.Title>
           <p>Where can i get some? The new site provides a closer look at our agency- What connects us,What excites us.......</p>
           <Link to="/package.jsonblogs">Readmore</Link>
            </Card.Body>
          </Card>
        </Col>      
      </Row>
      </div>
    </div>
  );
};

export default Inspiration;
